export default {
    dependencies: ['trackingservice'],
    callable(trackingservice) {
        trackingservice.trackEvent('promotions.profile.show', 'start');
    },
};



// WEBPACK FOOTER //
// ./controllers/extendedProfilePageTracking.js